import gql from 'graphql-tag';

export const UPDATE_ARTICLE_BUDGET_CAP = gql`
  mutation UpdateArticleBudgetCap($articleIds: [ID!]!, $budgetCap: Float!) {
    updateArticleBudgetCap(articleIds: $articleIds, budgetCap: $budgetCap) {
      articles {
        id
        budgetCapDollars
      }
      errors
    }
  }
`;
